import { render, staticRenderFns } from "./MediaCard.vue?vue&type=template&id=4a8cdbd9&scoped=true&"
import script from "./MediaCard.ts?vue&type=script&lang=ts&"
export * from "./MediaCard.ts?vue&type=script&lang=ts&"
import style0 from "./MediaCard.scss?vue&type=style&index=0&id=4a8cdbd9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8cdbd9",
  null
  
)

export default component.exports